import React from 'react'

const ALLOWED_KEYS = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End']

export const blockNonNumeric = (e: React.KeyboardEvent<HTMLElement>): void => {
  if (!ALLOWED_KEYS.includes(e.key) && !/^\d$/.test(e.key) && !e.ctrlKey && !e.metaKey) {
    e.preventDefault()
  }
}

export const blockNonNumericMax = (max: number) =>
  (e: React.KeyboardEvent<HTMLElement>): void => {
    if (!ALLOWED_KEYS.includes(e.key) && !/^\d$/.test(e.key) && !e.ctrlKey && !e.metaKey) {
      e.preventDefault()
      return
    }
    const input = e.target as HTMLInputElement
    const selectionLen = (input.selectionEnd ?? 0) - (input.selectionStart ?? 0)
    if (/^\d$/.test(e.key) && input.value.length - selectionLen >= max) {
      e.preventDefault()
    }
  }
